import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"edit\"><defs><style>#edit .cls-1{fill:none}</style></defs><title>资源 49</title><g id=\"edit_图层_2\" data-name=\"图层 2\"><g id=\"edit_图层_1-2\" data-name=\"图层 1\"><path id=\"edit_Rectangle_44\" data-name=\"Rectangle 44\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"edit_edit\"><path id=\"edit_Shape\" d=\"M2.34 22.5a.85.85 0 0 1 0-1.69h19.32a.85.85 0 0 1 0 1.69zm3.77-4.61a.75.75 0 0 1-.11-.83l2.34-5.51a.78.78 0 0 1 .16-.24L17.76 2a1.69 1.69 0 0 1 2.39 0L22 3.85a1.69 1.69 0 0 1 0 2.39l-9.3 9.31a.78.78 0 0 1-.24.16l-5.52 2.34a.75.75 0 0 1-.83-.16zm3.66-5.52l-1.36 3.22 3.22-1.36 6.53-6.54-1.85-1.85zM19 3.19l-1.5 1.45 1.86 1.86 1.45-1.45L19 3.19z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/edit.svg
// module id = KJUk
// module chunks = 6